// extracted by mini-css-extract-plugin
export var typingIndicator = "_ro-0";